// extracted by mini-css-extract-plugin
module.exports = {"image":"ItemDetails_image__zusqf","name":"ItemDetails_name__1Nn_r","details":"ItemDetails_details__1AQXy","link":"ItemDetails_link__1zqli"};